'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";
import moment from 'moment';

import {FaSyncAlt, FaTimes, FaPause, FaPlay, FaChevronDown} from "react-icons/fa";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ListGroup from "react-bootstrap/ListGroup";
import Badge from "react-bootstrap/Badge";
import Accordion from 'react-bootstrap/Accordion';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import Loader from "@uw-it-sis/lib-react/lib/Loader";

import auditStatusStore from './AuditStatusStore';
import {TimeStampFormat, ApiDateFormat} from '../lib/Constants';
import SysKeyForm from "./SyskeyForm";

function ContextAwareToggle({ children, eventKey, callback }) {
    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    );

    const keypress = (event) => {
        const key = event.key.toLowerCase();
        const code = event.code;
        const keyCode = event.keyCode;
        if (key === 'enter' || key === ' ' || code === "Space" || keyCode === 32 || keyCode === 13 ) {
            decoratedOnClick();
        }
    }

    return (
        <div role="button" tabIndex={0} className="d-flex justify-content-between align-items-center" onClick={decoratedOnClick} onKeyUp={keypress}>
            {children}
        </div>
    );
}

class AuditStatus extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = auditStatusStore;

        this.onClickReload = this.onClickReload.bind(this);
        this.onClickPausePoller = this.onClickPausePoller.bind(this);
        this.onClickResumePoller = this.onClickResumePoller.bind(this);
        this.onClickPauseProcessor = this.onClickPauseProcessor.bind(this);
        this.onClickResumeProcessor = this.onClickResumeProcessor.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.onClickCleanup = this.onClickCleanup.bind(this);
        this.buildDoneComponent = this.buildDoneComponent.bind(this);
    }

    componentDidMount() {
        this.store.loadStatus();
    }

    onClickReload = () => this.store.reloadStatus();

    onClickPausePoller = () => this.store.pausePoller();
    onClickResumePoller = () => this.store.resumePoller();

    onClickPauseProcessor = () => this.store.pauseProcessor();
    onClickResumeProcessor = () => this.store.resumeProcessor();

    onClickClear = () => this.store.clear()

    onClickCleanup = (syskey) => this.store.cleanupLockedRecord(syskey)
    _makeTimestamp(date, isDateTimeStamp = false) {
        if (date) {
            if (isDateTimeStamp) {
                return moment(date, ApiDateFormat).format(TimeStampFormat);
            } else {
                return moment(date).format(TimeStampFormat);
            }
        } else {
            return "Unset";
        }
    }

    buildDoneComponent() {
        let status = this.store.getStatus();

        const listItemClasses = "d-inline-flex justify-content-between align-items-center gap-5";

        let failurePollerMessages =
            <ListGroup.Item className={listItemClasses}>
                <strong>Failure Poller Reasons</strong>
                <Badge bg="success" pill>{status.poller.errorMessages.length}</Badge>
            </ListGroup.Item>;
        if (status.poller.errorMessages.length > 0) {
            let failurePollerMessagesList = status.poller.errorMessages.map(function(item, i) {
                return (<li key={i}>{item}</li>);
            });
            failurePollerMessages =
                <ListGroup.Item>
                    <ContextAwareToggle eventKey="failurePollerMessages">
                        <strong>Failure Poller Reasons</strong>
                        <div>
                            <Badge bg="danger" pill className="me-3">{status.poller.errorMessages.length}</Badge>
                            <FaChevronDown aria-hidden={true} />
                        </div>
                    </ContextAwareToggle>
                    <Accordion.Collapse eventKey="failurePollerMessages">
                        <ul className="my-3">{failurePollerMessagesList}</ul>
                    </Accordion.Collapse>
                </ListGroup.Item>;
        }

        let failureProcessorMessages =
            <ListGroup.Item className={listItemClasses}>
                <strong>Failure Processor Reasons</strong>
                <Badge bg="success" pill>{status.processor.errorMessages.length}</Badge>
            </ListGroup.Item>;
        if (status.processor.errorMessages.length > 0) {
            let failureProcessorMessagesList = status.processor.errorMessages.map(function(item, i) {
                return (<li key={i}>{item}</li>);
            });
            failureProcessorMessages =
                <ListGroup.Item>
                    <ContextAwareToggle eventKey="failureProcessorMessages">
                        <strong>Failure Processor Reasons</strong>
                        <div>
                            <Badge bg="danger" pill className="me-3">{status.processor.errorMessages.length}</Badge>
                            <FaChevronDown aria-hidden={true} />
                        </div>
                    </ContextAwareToggle>
                    <Accordion.Collapse eventKey="failureProcessorMessages">
                        <ul className="my-3">{failureProcessorMessagesList}</ul>
                    </Accordion.Collapse>
                </ListGroup.Item>;
        }

        let operationAlert;
        if (this.store.operationData.recentlyOperated) {
            operationAlert = (
                <Toast autohide delay={5000} show={true} bg="success">
                    <Toast.Header><strong className="me-auto">Audit Status</strong></Toast.Header>
                    <Toast.Body className="text-white">Completed {this.store.operationData.description} for Audit Listener</Toast.Body>
                </Toast>
            );
        }

        // Choose a button to render for pause/resume.
        let pauseResumePollerButton;
        if (status.poller.state !== "PAUSED") {
            pauseResumePollerButton =
                <Button
                    className="text-nowrap d-flex align-items-center"
                    title="Pause polling"
                    onClick={this.onClickPausePoller}>
                    <FaPause aria-hidden={true} className="me-2" /> Poller
                </Button>;
        } else {
            pauseResumePollerButton =
                <Button
                    className="text-nowrap d-flex align-items-center"
                    title="Resume polling"
                    onClick={this.onClickResumePoller}>
                    <FaPlay aria-hidden={true} className="me-2" /> Poller
                </Button>;
        }
        let pauseResumeProcessorButton;
        if (status.processor.state !== "PAUSED") {
            pauseResumeProcessorButton =
                <Button
                    className="text-nowrap d-flex align-items-center"
                    title="Pause processing"
                    onClick={this.onClickPauseProcessor}>
                    <FaPause aria-hidden={true} className="me-2" /> Processor
                </Button>;
        } else {
            pauseResumeProcessorButton =
                <Button
                    className="text-nowrap d-flex align-items-center"
                    title="Resume processing"
                    onClick={this.onClickResumeProcessor}>
                    <FaPlay aria-hidden={true} className="me-2" /> Processor
                </Button>;
        }

        return (
            <>
                <h1 className="h2">Audit Listener Status</h1>
                <ToastContainer className="p-4" position="top-end">
                    {operationAlert}
                </ToastContainer>
                <Loader
                    show={this.store.state === States.pending}
                    message="Updating Status..."
                    contentBlur={1}
                    disableDefaultStyles>
                    <Row>
                        <Col xs={12} md={8}>
                            <Accordion flush>
                                <ListGroup>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Needs Attention</strong>
                                        <Badge bg={status.needsAttention ? 'danger':'success'}>{status.needsAttention ? "Needs Attention" : "OK"}</Badge>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Error Threshold</strong>
                                        <span>{status.needsAttentionErrorThreshold}</span>
                                    </ListGroup.Item>

                                    {/**
                                     Poller data ...
                                     */}
                                    <ListGroup.Item variant={status.poller.state.toLowerCase() === "running"
                                    && parseInt(status.poller.failedIterationCount) === 0 ? "success":"warning"}>
                                        <h2 className="h4 my-1">Poller</h2>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>State</strong>
                                        <span>{status.poller.state}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Last Success</strong>
                                        <span>{this._makeTimestamp(status.poller.lastSuccessfulIteration)}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Last Failure</strong>
                                        <span>{this._makeTimestamp(status.poller.lastError)}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Queued Records Count</strong>
                                        <span>{status.poller.queuedMessagesCount}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Records Processed</strong>
                                        <span>{status.poller.recordsProcessed}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Poller Sleep Period</strong>
                                        <span>{status.poller.config.sleepPeriod}ms</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Poller Auto Recover Period</strong>
                                        <span>{status.poller.config.autoRecoverPeriod}s</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Failed Poller Count</strong>
                                        <Badge bg={parseInt(status.poller.failedIterationCount) > 0 ? 'danger':'success'} pill>{status.poller.failedIterationCount}</Badge>
                                    </ListGroup.Item>
                                    {failurePollerMessages}

                                    {/**
                                     Processor data ...
                                     */}
                                    <ListGroup.Item variant={status.processor.state.toLowerCase() === "running"
                                    && parseInt(status.processor.failedIterationCount) === 0 ? "success":"warning"}>
                                        <h2 className="h4 my-1">Processor</h2>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>State</strong>
                                        <span>{status.processor.state}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Last Success</strong>
                                        <span>{this._makeTimestamp(status.processor.lastSuccessfulIteration)}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Last Failure</strong>
                                        <span>{this._makeTimestamp(status.processor.lastError)}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Queued Records Count</strong>
                                        <span>{status.processor.queuedMessagesCount}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Records Processed</strong>
                                        <span>{status.processor.recordsProcessed}</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Processor Sleep Period</strong>
                                        <span>{status.processor.config.sleepPeriod}ms</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Processor Auto Recover Period</strong>
                                        <span>{status.processor.config.autoRecoverPeriod}s</span>
                                    </ListGroup.Item>
                                    <ListGroup.Item className={listItemClasses}>
                                        <strong>Failed Processor Count</strong>
                                        <Badge bg={parseInt(status.processor.failedIterationCount) > 0 ? 'danger':'success'} pill>{status.processor.failedIterationCount}</Badge>
                                    </ListGroup.Item>
                                    {failureProcessorMessages}
                                </ListGroup>
                            </Accordion>
                        </Col>
                        <Col xs={12} md={4} className="d-flex flex-column gap-5 align-items-start">
                            <ButtonGroup className="mx-auto">
                                <Button
                                    className="text-nowrap d-flex align-items-center"
                                    title="Get latest status"
                                    onClick={this.onClickReload}>
                                    <FaSyncAlt aria-hidden={true} className="me-2" /> Update
                                </Button>
                                {pauseResumePollerButton}
                                {pauseResumeProcessorButton}
                                <Button
                                    className="text-nowrap d-flex align-items-center"
                                    title="Clear errors"
                                    onClick={this.onClickClear}>
                                    <FaTimes aria-hidden={true} className="me-2" /> Clear
                                </Button>
                            </ButtonGroup>
                            <SysKeyForm onCleanup={this.onClickCleanup}/>
                        </Col>
                    </Row>
                </Loader>
            </>
        )
    }

    render() {
        // Use 'dots' animation for first time load of course section data
        let pendingComponent = "border";

        if ( this.store.hasData() ) {
            pendingComponent = this.buildDoneComponent;
        }

        return (
            <SimpleState
                state={this.store.state}
                pendingComponentBuilder={pendingComponent}
                doneComponentBuilder={this.buildDoneComponent}
                name="AuditStatus"
            />
        );
    }
}

export default observer(AuditStatus);
